/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './';
export function ApplicationVersionResponseFromJSON(json) {
    return ApplicationVersionResponseFromJSONTyped(json, false);
}
export function ApplicationVersionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'buildNumber': !exists(json, 'buildNumber') ? undefined : json['buildNumber'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'version': !exists(json, 'version') ? undefined : json['version']
    };
}
export function ApplicationVersionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'buildNumber': value.buildNumber,
        'metaData': MetaDataToJSON(value.metaData),
        'version': value.version
    };
}
